namespace GeniuzPOS.Purchase {
    export class ListAppCnrtvColumns {
        static columnsKey = 'Purchase.ListAppCnrtv';
    }
}
